import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { setQueryParams } from '../../../../helper/utils';
import './style.css';

import ApplyFiltersButton from './components/ApplyFiltersButton';
import RangeSlider from './components/RangeSlider';
import Categories from './components/Categories';
import DeliveryDays from './components/DeliveryDays';
import ShippingCountry from './components/ShippingCountry';
import AmazonFriendly from './components/AmazonFriendly';

/* Filter Bounds */
const minPriceBound = 0;
const maxPriceBound = 20000;
const minSoldBound = 0;
const maxSoldBound = 50000;

/* initial Filter State */
const initialFilterState = {
  minPrice: minPriceBound,
  maxPrice: maxPriceBound,
  minSold: minSoldBound,
  maxSold: maxSoldBound,
};

export default function ProductFilteration({ setQuery, setContentId, setPage, isAlibabaSearch = false }) {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [pendingFilters, setPendingFilters] = useState(initialFilterState);

  useEffect(() => {
    /*  Initialize pendingFilters from URL parameters on mount */
    const params = new URLSearchParams(location.search);
    const minPrice = Number(params.get('min')) || minPriceBound;
    const maxPrice = Number(params.get('max')) || maxPriceBound;
    const minSold = Number(params.get('monthSoldMin')) || minSoldBound;
    const maxSold = Number(params.get('monthSoldMax')) || maxSoldBound;

    setPendingFilters({
      minPrice: minPrice,
      maxPrice: maxPrice,
      minSold: minSold,
      maxSold: maxSold,
    });
  }, []);

  useEffect(() => {
    setQuery(setQueryParams(searchParams));
  }, [location]);

  const removeFilters = () => {
    const next = new URLSearchParams(location.search);
    next.delete('min');
    next.delete('max');
    next.delete('monthSoldMin');
    next.delete('monthSoldMax');
    next.delete('apply');
    setPendingFilters(initialFilterState);
    navigate(`${location.pathname}?${next.toString()}`);
  };

  const applyFilters = () => {
    const next = new URLSearchParams(location.search);

    // Apply price filters if they exist
    if (pendingFilters.minPrice) next.set('min', String(pendingFilters.minPrice));
    if (pendingFilters.maxPrice) next.set('max', String(pendingFilters.maxPrice));

    // Apply month sold filters if they exist
    if (pendingFilters.minSold) next.set('monthSoldMin', String(pendingFilters.minSold));
    if (pendingFilters.maxSold) next.set('monthSoldMax', String(pendingFilters.maxSold));

    // Mark as applied so Products fetches with current URL params
    next.set('apply', '1');

    // Reset to page 1 when applying filters
    next.delete('page');
    setPage(1);

    navigate(`${location.pathname}?${next.toString()}`, { replace: true });
  };

  const hasPendingFilters = () =>
    pendingFilters.minPrice || pendingFilters.maxPrice || pendingFilters.minSold || pendingFilters.maxSold;

  return (
    <div>
      <div className="clear_all_filters" onClick={removeFilters}>
        CLEAR ALL
      </div>

      {isAlibabaSearch ? (
        <div className="product_filteration_container">
          <RangeSlider
            title="PRICE"
            minBound={minPriceBound}
            maxBound={maxPriceBound}
            minParam="min"
            maxParam="max"
            prefix="₹"
            setPendingFilters={setPendingFilters}
            pendingFilters={pendingFilters}
            minKey="minPrice"
            maxKey="maxPrice"
          />

          <RangeSlider
            title="MONTHLY SOLD"
            minBound={minSoldBound}
            maxBound={maxSoldBound}
            minParam="monthSoldMin"
            maxParam="monthSoldMax"
            setPendingFilters={setPendingFilters}
            pendingFilters={pendingFilters}
            minKey="minSold"
            maxKey="maxSold"
          />

          <ApplyFiltersButton hasFilters={hasPendingFilters()} onApply={applyFilters} />

          <DeliveryDays setPage={setPage} />
          <ShippingCountry setPage={setPage} />
        </div>
      ) : (
        <div className="product_filteration_container">
          <Categories setContentId={setContentId} setPage={setPage} isAlibabaSearch={false} />
          <AmazonFriendly setPage={setPage} />

          <RangeSlider
            title="PRICE"
            minBound={minPriceBound}
            maxBound={maxPriceBound}
            minParam="min"
            maxParam="max"
            prefix="₹"
            setPendingFilters={setPendingFilters}
            pendingFilters={pendingFilters}
            minKey="minPrice"
            maxKey="maxPrice"
          />

          <ApplyFiltersButton hasFilters={hasPendingFilters()} onApply={applyFilters} />

          <DeliveryDays setPage={setPage} />
          <ShippingCountry setPage={setPage} />
        </div>
      )}
    </div>
  );
}
